<template>
  <div class="loginContainer">
    <div class="titleBar">
      <span class="mainColor textGap">
        {{ $t("user.register") }}
      </span>
    </div>
    <div class="formContainer">
      <a-form :form="form" @submit="handleSubmit">
        <phone-and-email-form-item class="phoneInput" />
        <captcha-form-item
          :phoneNumber="currentPhoneNumber"
          :dynamicCodeType="dynamicCodeType"
        />
        <password-form-item
          :placeholder="$t('user.register.pwd.placeholder')"
        />
        <a-form-item class="agreementCheckBox">
          <a-checkbox
            class="checkbox"
            v-decorator="[
              'agreement',
              {
                valuePropName: 'checked',
                rules: [
                  {
                    validator: checkAgreement,
                  },
                ],
              },
            ]"
          >
            <span>{{ $t("user.register.agreement.txt1") }}</span>
            <a-button
              type="link"
              class="agreementLink"
              @click="openWindow('/userterm')"
            >
              {{ $t("user.register.agreement.user") }}
            </a-button>
            <span :style="isEn ? { marginLeft: '26px' } : {}">{{
              $t("user.register.agreement.txt2")
            }}</span>
            <a-button
              type="link"
              class="agreementLink"
              @click="openWindow('/privacy')"
            >
              {{ $t("user.register.agreement.privacy") }}
            </a-button>
          </a-checkbox>
        </a-form-item>
        <a-button
          block
          type="primary"
          html-type="submit"
          class="registerBtn radiusBtnFull"
          :loading="isSubmitting"
        >
          {{ $t("user.register.submit") }}
        </a-button>
      </a-form>
      <div class="toCodeLogin">
        <span class="toCodeLoginBtn" @click="goTo(passwordLoginFormType)">
          {{ $t("user.register.login") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/** 注册表单 */
import { pickPhoneNumberOrEmail } from "@/utils/validator";
import PhoneAndEmailFormItem from "./PhoneAndEmailFormItem";
import PasswordFormItem from "./PasswordFormItem";
import CaptchaFormItem from "./CaptchaFormItem";
import { FormType } from "@/models/user";
import { DynamicCodeType } from "@/models/user";
import UserApi from "@/api/user";
import { JwtUtil } from "@/utils/jwt";

export default {
  name: "RegisteForm",
  components: {
    PhoneAndEmailFormItem,
    PasswordFormItem,
    CaptchaFormItem,
  },
  props: {
    goTo: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      form: null,
      dynamicCodeType: DynamicCodeType.REGISTER,
      isSubmitting: false,
      passwordLoginFormType: FormType.PASSWORD_LOGIN,
      currentPhoneNumber: undefined,
    };
  },
  created() {
    this.form = this.$form.createForm(this, {
      name: "registe",
      onValuesChange: (_, values) => {
        if (values.phoneNumber !== undefined) {
          this.currentPhoneNumber = values.phoneNumber;
        }
      },
    });
  },
  computed: {
    isEn: function() {
      return this.$i18n.locale === "en-US";
    },
  },
  methods: {
    checkAgreement(rule, value, callback) {
      value ? callback() : callback(new Error(this.$t("user.agreement.error")));
    },
    openWindow(path) {
      window.open(path);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          /** 判断输入项是手机号还是邮箱 */
          const newValues = pickPhoneNumberOrEmail(values);
          delete newValues.agreement;
          this.isSubmitting = true;
          UserApi.register(newValues)
            .then((res) => {
              JwtUtil.setJwtToken(
                (res.data.legal_entities[0].token || "").replace("Bearer ", "")
              );
              window.location.href = "/";
            })
            .catch((e) => {
              this.$message.error(e.message);
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../common.less";

.checkbox {
  * {
    font-size: @font-size-sm;
  }
  line-height: 1.5;
}
</style>
